import React from 'react';


const BenefitsSection = () => {
  const benefits = [
  {
    icon: 'TrendingUp',
    title: 'Track Every Dollar',
    description: 'Comprehensive transaction tracking across all your accounts'
  },
  {
    icon: 'PieChart',
    title: 'Smart Categorization',
    description: 'Automatic expense categorization with custom rules'
  },
  {
    icon: 'Upload',
    title: 'Easy CSV Import',
    description: 'Import bank statements instantly with our CSV processor'
  },
  {
    icon: 'BarChart3',
    title: 'Financial Insights',
    description: 'Detailed analytics and trend visualization for better decisions'
  },
  {
    icon: 'Target',
    title: 'Budget Goals',
    description: 'Set and track financial goals with achievement milestones'
  },
  {
    icon: 'Globe',
    title: 'Multi-Currency',
    description: 'Manage accounts in different currencies with ease'
  }];


  return;


































};

export default BenefitsSection;